import { useEffect, useState } from "react";
import { getSignedFileUrl } from "../lib/api";

// Renders an <img> whose src is a short-lived signed file URL (SEC-002).
export function SignedImage({ path, alt, className, testid }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let ok = true;
    setSrc(null);
    if (path) getSignedFileUrl(path).then((u) => { if (ok) setSrc(u); }).catch(() => {});
    return () => { ok = false; };
  }, [path]);
  if (!path) return null;
  return <img src={src || undefined} alt={alt} className={className} data-testid={testid} />;
}
